import { shopPrefix } from '../../config';
import { EntryPageFilterResponse } from '../../store/api';
import { AgeCategory } from '../../../models/AgeCategory';
import { CategoryPageBucketEntry, CategoryPageType } from '../../../models/CategoryPage';
import { mapCategoryPageBuckets } from './mapCategoryPageBuckets';
import { LoanFormat } from '../../../models/LoanFormat';
import { http } from '../axios';

const FETCH_CATEGORY_PAGE_URL = `${shopPrefix}/v1/entrypages/:categoryPage/:loanFormat`;

export type FetchCategoryPageResponse = {
    readonly buckets: ReadonlyArray<CategoryPageBucketEntry>;
    readonly topBuckets: ReadonlyArray<CategoryPageBucketEntry>;
};
export type FetchCategoryPageOpts = {
    readonly loanFormat?: LoanFormat;
    readonly ageCategory?: AgeCategory;
    readonly shopLanguage?: string;
};

export const fetchCategoryPage = (
    categoryPage: CategoryPageType,
    { loanFormat, ageCategory, shopLanguage }: FetchCategoryPageOpts = {}
): Promise<FetchCategoryPageResponse> => {
    return http
        .get<EntryPageFilterResponse>(FETCH_CATEGORY_PAGE_URL, {
            pathParams: { categoryPage, loanFormat: loanFormat ? loanFormat.toUpperCase() : undefined },
            params: { ageCategory, shopLanguage }
        })
        .then(response => ({
            buckets: mapCategoryPageBuckets(response.data.buckets),
            topBuckets: mapCategoryPageBuckets(response.data.topBuckets)
        }));
};
